import {
  HIDE_QUOTA_PAYWALL,
  HIDE_SESSION_ENDED,
  OPEN_PLANS,
  REQUEST_TUTOR_RESTART,
  SET_BUY_MORE,
  SET_PLAN_INFO,
  SHOW_QUOTA_PAYWALL,
} from './actionTypes';

/** A limit (used-up meter, locked unit) or a session end; the world shows the right thing for it. */
export const showQuotaPaywall = details => ({
  type: SHOW_QUOTA_PAYWALL,
  payload: details || {},
});

export const hideQuotaPaywall = () => ({type: HIDE_QUOTA_PAYWALL});

/** The full-screen plans with no limit behind them (the Upgrade pill in the top bar). */
export const openPlans = () => ({type: OPEN_PLANS});

export const setBuyMore = open => ({type: SET_BUY_MORE, payload: Boolean(open)});

/** The learner's plan, for the Upgrade pill and the plan cards. */
export const setPlanInfo = plan => ({type: SET_PLAN_INFO, payload: plan || null});

export const hideSessionEnded = () => ({type: HIDE_SESSION_ENDED});

/**
 * Start the tutor from outside its controls: "Use Chat instead" on the plans passes the mode; with
 * no mode the controls open the Voice / Chat choice.
 */
export const requestTutorRestart = mode => ({type: REQUEST_TUTOR_RESTART, payload: mode || null});
/** "Type instead" / "Talk instead" on the tutor bar: end this session and start one in `mode`, the world kept as it is. */
export const requestTutorSwitch = mode => ({type: REQUEST_TUTOR_RESTART, payload: mode || null, meta: {switch: true}});
